/* eslint-disable react/prop-types */
import { Button, TableCell, TableRow } from "@mui/material";
import React from "react";
import { getGohonzonType } from "../../utils";
import { isEmptyObj } from "../../utils/helper";
import { style, tabelCellWidth } from "./styles";
import Typography from "../common/new/Typography/Typography";

function GohonzonApplications({ member, onMemberSelect }) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  const { memberDetails } = member;
  return (
    <TableRow style={style.tableRow}>
      <TableCell style={{ ...style.rowStyleId, ...tabelCellWidth.tiny }}>
        {" "}
        {member.memberId}
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.mini }}>
        {" "}
        <Typography style={style.typogrphyStyle}>
          {memberDetails.fullName}
        </Typography>{" "}
        <br />{" "}
        <Typography style={style.typogrphyStyle}>
          {memberDetails.addressLine1}
        </Typography>
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.tiny }}>
        {" "}
        <Typography style={style.typogrphyStyle}>
          {memberDetails.mobileNumber || "-"}{" "}
        </Typography>
        <br />
        <Typography style={style.typogrphyStyle}>
          {memberDetails.emailId}
        </Typography>
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography style={style.typogrphyStyle}>
          {memberDetails.divisionName || "-"}
        </Typography>
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography style={style.typogrphyStyle}>
          {member?.districtName || "-"}
        </Typography>
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography style={style.typogrphyStyle}>
          {getGohonzonType(member.gohonzonType)}
        </Typography>
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <Button
          style={style.applyButton}
          onClick={() => onMemberSelect(member.memberId)}
        >
          APPLY
        </Button>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonApplications;
